import React, { Suspense } from "react";
import { FormattedMessage, defineMessages, injectIntl } from "react-intl";
import { IconClose, IconWhiteSelected } from "../../icons/svg";


const messages = defineMessages({
	send_excel_text_title: {
		id: "send_excel_text_title",
		defaultMessage: "Select sending format",
		description: "Select sending format",
	},
	send_excel_image: {
		id: "send_excel_image",
		defaultMessage: "Send as photo",
		description: "Send as photo",
	},
	send_excel_text: {
		id: "send_excel_text",
		defaultMessage: "Send as text",
		description: "Send as text",
	},
	button_confirm: {
		id: "button_confirm",
		defaultMessage: "Confirm",
		description: "Confirm",
	},
	button_cancel: {
		id: "button_cancel",
		defaultMessage: "Cancel",
		description: "Cancel",
	}
})

class SendExcelText extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			isSendText: false,
		}

		this.selectSendText = this.selectSendText.bind(this)
		this.handleSendMessage = this.handleSendMessage.bind(this)
	}

	

	selectSendText(isSendText) {
		this.setState({ isSendText })
	}

	handleSendMessage() {
		if (this.state.isSendText) {
			this.props.onSendText()
		} else {
			this.props.onSendImage()
		}
		this.props.onClose()
	}


	render() {
		const { formatMessage } = this.props.intl;
		const { isSendText } = this.state

		let classNameSendText = 'select-item ' + (isSendText ? 'highlight' : 'normal')
		let classNameSendImage = 'select-item ' + (isSendText ? 'normal' : 'highlight')

		return (
			<Suspense
				fallback={
					<div className="panel-form-row">
						<FormattedMessage
							id="loading_note"
							defaultMessage="Loading..."
							description="Message shown when component is loading"
						/>
					</div>
				}>
				<div className="dialog-send-excel-text">
					<div className="header">
						<div className="title">
							{formatMessage(messages.send_excel_text_title)}
						</div>
						<div className="icon" onClick={this.props.onClose}>
							<IconClose />
						</div>
					</div>
					<div className="dialog-send-excel-text-content">
						<div className="img-excel-preview-container">
							<img className="img-excel-preview" src={URL.createObjectURL(this.props.imageExcel)} alt="img-excel-preview" />
						</div>
						<div className={classNameSendImage} onClick={() => this.selectSendText(false)}>
							<div>{formatMessage(messages.send_excel_image)}</div>
							{!isSendText && <div className="icon-selected"><IconWhiteSelected /></div>}
						</div>
						<div className={classNameSendText} onClick={() => this.selectSendText(true)}>
							<div>{formatMessage(messages.send_excel_text)}</div>
							{isSendText && <IconWhiteSelected />}
						</div>
					</div>
					<div className="dialog-send-excel-text-footer">
						<button className="btn btn-close" onClick={this.props.onClose}>{formatMessage(messages.button_cancel)}</button>
						<button className="btn btn-ok" onClick={this.handleSendMessage}>{formatMessage(messages.button_confirm)}</button>
					</div>
				</div>
			</Suspense>
		)
	}
}

export default injectIntl(SendExcelText);